import { ValidationResult, RequiredFieldCheck } from '@/views/helpers/validation-result';
// import ValidationMessages from '@/views/helpers/validation-messages';

export default {
  validate (employmentRelationshipDetail) {
    let validationResult = new ValidationResult();

    return validationResult;
  },

  requiredFields (employmentRelationshipDetail) {
    let validationResult = new ValidationResult();

    validationResult.push(RequiredFieldCheck('fromDate', employmentRelationshipDetail.fromDate));
    validationResult.push(RequiredFieldCheck('natureOfEmployment', employmentRelationshipDetail.natureOfEmployment));
    validationResult.push(RequiredFieldCheck('grossAnnualSalary', employmentRelationshipDetail.grossAnnualSalary));
    validationResult.push(RequiredFieldCheck('professionClassification', employmentRelationshipDetail.professionClassification));
    validationResult.push(RequiredFieldCheck('noRisk', employmentRelationshipDetail.noRisk));

    return validationResult;
  }
};
